const component = require('../component/component');

const uniqueChecker = Object.assign({}, component, {
    justWarn: false,
    checkIfHidden: false,
    componentIds: {},
    warnComponentIds: [],
    events: {},

    inited: function () {
        for (let attribute in this.events) {
            let event = this.events[attribute];
            let component = false;
            let componentId = this.componentIds[attribute];

            if (typeof this.hm.app.components[componentId] !== typeof undefined) {
                component = this.hm.app.components[componentId];
            }

            if (component !== false) {
                component.element.addEventListener(event, () => { this.startTimer('uniqueCheck_' + this.id, () => { this.check(); }) });
            }
        }
    },

    check: async function () {
        this.hm.app.blockSubmitActions('uniqueChecker_' + this.id);

        let doCheck = true;

        let data = {
            configHash: this.configHash,
            componentAction: 'checkUnique',
        };

        for (let attribute in this.componentIds) {
            let componentId = this.componentIds[attribute];

            if (typeof this.hm.app.components[componentId] !== typeof undefined && (!this.hm.helper.isHidden(this.hm.app.components[componentId]) || this.checkIfHidden)) {
                let value = this.hm.app.components[componentId].getValue();

                if (value === '') {
                    doCheck = false;
                    break;
                }

                data[attribute] = value;
            }
        }

        if (doCheck) {
            this.warnComponentIds.forEach((warnComponentId) => {
                if (typeof this.hm.app.components[warnComponentId] !== typeof undefined && !this.hm.helper.isHidden(this.hm.app.components[warnComponentId])) {
                    let warnComponent = this.hm.app.components[warnComponentId];
                    this.hm.validator.resetValidation(warnComponent);
                }
            });
            
            /*
            //old part, here the warnComponentIds can only be some of the componentIds
            for (let attribute in this.componentIds) {
                let componentId = this.componentIds[attribute];
                if (typeof this.hm.app.components[componentId] !== typeof undefined && !this.hm.helper.isHidden(this.hm.app.components[componentId]) && this.warnComponentIds.includes(componentId)) {
                    this.hm.validator.resetValidation(this.hm.app.components[componentId]);
                }
            }
            */

            let response = await this.hm.app.fetchJson('components', 'main', data);

            if (!response.result) {
                this.warnComponentIds.forEach((warnComponentId) => {
                    if (typeof this.hm.app.components[warnComponentId] !== typeof undefined && !this.hm.helper.isHidden(this.hm.app.components[warnComponentId])) {
                        let warnComponent = this.hm.app.components[warnComponentId];
                        let message = this.hm.app.messages.validation_unique.text;
                        if (typeof response.message !== typeof undefined) {
                            message = response.message;
                        }
                        //this.hm.log('invalid component', this.hm.app.components[componentId]);
                        this.hm.validator.invalidateForRule(warnComponent, 'uniqueCheck_' + this.id, message, this.justWarn);
                        this.hm.validator.resolveValidation(warnComponent);
                    }
                });
                /*
                //old part, here the warnComponentIds can only be some of the componentIds
                for (let attribute in this.componentIds) {
                    let componentId = this.componentIds[attribute];
                    if (typeof this.hm.app.components[componentId] !== typeof undefined && !this.hm.helper.isHidden(this.hm.app.components[componentId]) && this.warnComponentIds.includes(componentId)) {
                        let message = this.hm.app.messages.validation_unique.text;
                        if (typeof response.message !== typeof undefined) {
                            message = response.message;
                        }
                        //this.hm.log('invalid component', this.hm.app.components[componentId]);
                        this.hm.validator.invalidateForRule(this.hm.app.components[componentId], 'uniqueCheck_' + this.id, message, this.justWarn);
                        this.hm.validator.resolveValidation(this.hm.app.components[componentId]);
                    }
                }
                */
            }
        }

        this.clearTimer('uniqueCheck_' + this.id);
        this.hm.app.releaseSubmitActions('uniqueChecker_' + this.id);
    }

});

module.exports = uniqueChecker;